export default __webpack_public_path__ + "static/media/medaille-qdo-argent-usage.82be38af.png";